import { LEDGER_TYPES, CUSTOM_FIELDS, TAGS, BUSINESS_TYPES } from "../shared/tagTypes";
import { baseApi } from "./base";

const miscApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [LEDGER_TYPES, CUSTOM_FIELDS, TAGS, BUSINESS_TYPES],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getLedgerTypes: builder.query({
                query: () => ({
                    url: "/ledger-types",
                }),
                providesTags: [LEDGER_TYPES],
            }),
            getVoucherCustomFields: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/voucher-fields`
                }),
                providesTags: [CUSTOM_FIELDS],
            }),
            getVoucherFormCustomFields: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/voucher-fields`,
                    params: {
                        form: payload.form
                    }
                }),
                providesTags: [CUSTOM_FIELDS],
            }),
            saveVoucherCustomFields: builder.mutation({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/voucher-fields`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [CUSTOM_FIELDS],
            }),
            getVoucherTags: builder.query({
                query: (payload) => ({
                    url: `/companies/${payload.companyId}/voucher-tags`
                }),
                providesTags: [TAGS],
            }),
            getBusinessTypes: builder.query({
                query: () => ({
                    url: "/business-types"
                }),
                providesTags: [BUSINESS_TYPES],
            }),
        }),

        overrideExisting: false,
    });

export const {
    useGetLedgerTypesQuery,
    useLazyGetLedgerTypesQuery,
    useGetVoucherCustomFieldsQuery,
    useLazyGetVoucherCustomFieldsQuery,
    useGetVoucherFormCustomFieldsQuery,
    useLazyGetVoucherFormCustomFieldsQuery,
    useSaveVoucherCustomFieldsMutation,
    useGetVoucherTagsQuery,
    useLazyGetVoucherTagsQuery,
    useGetBusinessTypesQuery,
    useLazyGetBusinessTypesQuery
} = miscApi;
